import { type Component, createSignal } from "solid-js"
import { login } from "../lib/api.js"

interface Props {
  onLogin: () => void
}

export const Login: Component<Props> = (props) => {
  const [email, setEmail] = createSignal("")
  const [password, setPassword] = createSignal("")
  const [showPassword, setShowPassword] = createSignal(false)
  const [error, setError] = createSignal<string | null>(null)
  const [loading, setLoading] = createSignal(false)

  const handleSubmit = async (e: Event): Promise<void> => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    try {
      await login(email(), password())
      props.onLogin()
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div class="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <form
        onSubmit={(e) => {
          void handleSubmit(e)
        }}
        class="bg-white rounded-lg shadow-lg p-8 w-full max-w-md"
      >
        <h1 class="text-2xl font-bold text-center text-gray-900 mb-6">
          Eckersdorf
        </h1>

        {error() !== null && (
          <div class="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded mb-4 text-sm">
            {error()}
          </div>
        )}

        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            value={email()}
            onInput={(e) => setEmail(e.currentTarget.value)}
            required
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div class="mb-6">
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Hasło
          </label>
          <div class="relative">
           <input
             type={showPassword() ? "text" : "password"}
             value={password()}
             onInput={(e) => setPassword(e.currentTarget.value)}
             required
              class="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
           />
           <button
             type="button"
             class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none"
             onClick={() => setShowPassword(!showPassword())}
              aria-label={showPassword() ? "Ukryj hasło" : "Pokaż hasło"}
           >
             {showPassword() ? (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.644C3.412 7.943 7.244 4.5 12 4.5c4.756 0 8.773 3.162 10.065 7.498a1.01 1.01 0 010 .644C20.588 16.057 16.756 19.5 12 19.5c-4.756 0-8.773-3.162-10.065-7.498z" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              )}
            </button>
          </div>
        </div>

        <button
          type="submit"
          disabled={loading()}
          class={`w-full px-4 py-2 rounded-md font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors ${loading() ? "opacity-50 cursor-not-allowed" : ""}`}
        >
          {loading() ? "Logowanie..." : "Zaloguj się"}
        </button>
      </form>
    </div>
  )
}
